import { render } from "./ScienceAdd.vue?vue&type=template&id=4f6112e6"
import script from "./ScienceAdd.vue?vue&type=script&lang=js"
export * from "./ScienceAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__